import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/content";

const heightFor = (span) => {
  if (span === "tall") return "h-[440px] md:h-[560px]";
  if (span === "wide") return "h-[320px] md:h-[420px]";
  return "h-[300px] md:h-[380px]";
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-white py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <div className="eyebrow">Services</div>
            <h2 className="font-serif-display text-[#111] mt-4 text-4xl md:text-6xl leading-[1.05] tracking-tight">
              Every repair, <span className="italic text-[#C8A44D]">expertly</span> handled.
            </h2>
          </div>
          <p className="text-[#555] max-w-md text-base md:text-lg font-light leading-relaxed">
            From a single shelf to a full punch list — we approach every job
            with the precision and pride of a craftsman.
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 [column-fill:_balance]">
          {SERVICES.map((s, i) => (
            <article
              key={s.title}
              data-testid={`service-card-${i}`}
              className={`group relative mb-6 break-inside-avoid overflow-hidden rounded-2xl ${heightFor(
                s.span
              )}`}
            >
              <img
                src={s.image}
                alt={s.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
              <div className="absolute inset-0 p-7 flex flex-col justify-end text-white">
                <div className="flex items-center gap-2 text-[10px] tracking-[0.3em] uppercase text-[#C8A44D]">
                  <span className="w-5 h-px bg-[#C8A44D]" />
                  0{(i % 9) + 1}
                </div>
                <h3 className="font-serif-display text-2xl md:text-3xl mt-3 tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-white/75 font-light leading-relaxed max-w-sm">
                  {s.desc}
                </p>
                <a
                  href="#estimate"
                  data-testid={`service-cta-${i}`}
                  className="mt-5 inline-flex items-center gap-2 text-xs tracking-[0.24em] uppercase text-white hover:text-[#C8A44D] transition-colors"
                >
                  Request Estimate
                  <ArrowUpRight size={14} strokeWidth={1.75} />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
